import { render, staticRenderFns } from "./BatchAddPendingPayment.vue?vue&type=template&id=2d921cb8&scoped=true"
import script from "./BatchAddPendingPayment.vue?vue&type=script&lang=js"
export * from "./BatchAddPendingPayment.vue?vue&type=script&lang=js"
import style0 from "./BatchAddPendingPayment.vue?vue&type=style&index=0&id=2d921cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d921cb8",
  null
  
)

export default component.exports